<template>
  <div class="tw-w-full">
    <ul class="tw-grid tw-grid-cols-1 xs:tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-2">
      <li
        v-for="motor in motoresOrdenados(motores)"
        :key="motor.id"
        @click="openModal(motor)"
        :class="[
          modoOperacao == 0 ? 'hover:hover:tw-shadow-xl hover:tw-shadow-emerald-500/10 hover:-tw-translate-y-1 tw-cursor-pointer' : '',
          theme == 'dark' 
            ? 'tw-bg-[#334155]' 
            : 'tw-bg-white',
          'tw-group tw-relative tw-flex tw-items-center tw-gap-2 tw-p-2 tw-shadow-lg tw-rounded-2xl'
        ]"
      >
        <div class="tw-relative tw-flex tw-items-center tw-justify-center">
          <div :class="[
            motor.status === 1 ? 'tw-bg-emerald-500' : 'tw-bg-slate-400',
            'tw-w-12 tw-h-12 tw-rounded-xl tw-flex tw-items-center tw-justify-center'
          ]">
            <img
                src="/images/icons/ventilador2.png"
                alt="Motor Ligado"
                class="tw-w-7 tw-h-7 tw-brightness-0 tw-invert"
                :class="motor.status === 1 ? 'tw-animate-spin' : ''"
            />
          </div>
        </div>

        <div class="tw-flex-1 tw-min-w-0">
          <div class="tw-flex tw-items-center tw-gap-2">
            <h5 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-font-bold tw-text-base tw-truncate">
              {{ motor.descricao }}
            </h5>
            <span :class="motor.status === 1 ? 'tw-text-emerald-500' : 'tw-text-slate-500'" class="tw-text-[12px] tw-font-bold tw-uppercase tw-whitespace-nowrap">
              {{ motor.status === 1 ? "Ligado" : "Desligado" }}
            </span>
          </div>
          <small class="tw-block tw-text-[10px] tw-text-slate-400 tw-font-medium tw-whitespace-nowrap">{{ aeracaoData }}</small>
          <small
            v-if="motor.modulo_chave != null"
            :class="Number(motor.modulo_chave) === 0 && aeracaoPossivel ? 'tw-text-red-500' : 'tw-text-slate-400'"
            class="tw-block tw-text-[10px] tw-font-bold tw-uppercase tw-whitespace-nowrap"
          >
            Chave: {{ Number(motor.modulo_chave) === 1 ? 'Auto' : 'Manual' }}
          </small>
        </div>
      </li>
    </ul>

    <div>
      <div v-if="showModal && modoOperacao == 0" class="tw-fixed tw-inset-0 tw-bg-black/60 tw-flex tw-justify-center tw-items-center tw-z-[99999] tw-p-4" @click.self="closeModal">
        <div
          :class="theme === 'dark' ? 'tw-bg-[#1A1D21]' : 'tw-bg-white'"
          class="tw-w-full tw-max-w-[360px] tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden"
        >
          <div class="tw-flex tw-items-center tw-gap-3 tw-p-5">
            <div :class="selectedMotor.status === 1 ? 'tw-bg-emerald-500' : (theme === 'dark' ? 'tw-bg-[#334155]' : 'tw-bg-slate-400')" class="tw-w-11 tw-h-11 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
              <img
                src="/images/icons/ventilador2.png"
                alt="Motor"
                class="tw-w-6 tw-h-6 tw-brightness-0 tw-invert"
                :class="selectedMotor.status === 1 ? 'tw-animate-spin' : ''"
              />
            </div>
            <div class="tw-flex-1 tw-min-w-0">
              <p class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-400">Acionamento manual</p>
              <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-font-bold tw-text-base tw-truncate">{{ selectedMotor.descricao }}</h3>
            </div>
            <button
              @click="closeModal"
              :class="theme === 'dark' ? 'tw-text-slate-500 hover:tw-text-slate-200 hover:tw-bg-white/5' : 'tw-text-slate-400 hover:tw-text-slate-700 hover:tw-bg-slate-100'"
              class="tw-w-8 tw-h-8 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-self-start"
              aria-label="Fechar"
            >
              <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div :class="theme === 'dark' ? 'tw-bg-white/[0.04]' : 'tw-bg-slate-50'" class="tw-mx-5 tw-rounded-xl tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between">
            <span class="tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-slate-400">Status atual</span>
            <span class="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-font-bold tw-uppercase">
              <span :class="selectedMotor.status === 1 ? 'tw-bg-emerald-500' : 'tw-bg-slate-500'" class="tw-w-2 tw-h-2 tw-rounded-full"></span>
              <span :class="selectedMotor.status === 1 ? 'tw-text-emerald-500' : 'tw-text-slate-500'">{{ selectedMotor.status === 1 ? 'Ligado' : 'Desligado' }}</span>
            </span>
          </div>

          <div class="tw-grid tw-grid-cols-2 tw-gap-3 tw-p-5">
            <button
              class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-py-3 tw-rounded-xl tw-font-bold tw-text-xs tw-uppercase tw-tracking-wider tw-bg-emerald-600 hover:tw-bg-emerald-500 tw-text-white active:tw-scale-95 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              @click="sendCommandManual(1)"
              :disabled="disable"
            >
              <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" />
              </svg>
              Ligar
            </button>
            <button
              :class="theme === 'dark'
                ? 'tw-bg-white/5 tw-text-slate-300 hover:tw-bg-red-500/15 hover:tw-text-red-400'
                : 'tw-bg-slate-100 tw-text-slate-600 hover:tw-bg-red-50 hover:tw-text-red-600'"
              class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-py-3 tw-rounded-xl tw-font-bold tw-text-xs tw-uppercase tw-tracking-wider active:tw-scale-95 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              @click="sendCommandManual(0)"
              :disabled="disable"
            >
              <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <rect x="6" y="6" width="12" height="12" rx="2" />
              </svg>
              Desligar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";

export default {
    setup () {
        const route = useRoute();
        const toast = useToast();

        return {
            siloId: route.params.silo,
            toast
        };
    },
    props: {
        motores: {
            type: Array,
            default: () => [],
        },
        aeracaoData: {
            type: [String, Date],
            default: null,
        },
        modoOperacao: {
            type: Number,
            default: 1,
        },
        aeracaoPossivel: {
            type: Boolean,
            default: false,
        },
        theme: {
            type: String,
        },
    },
    computed: {
        isTermocloud() {
            return String(this.$store.state.unidade.unidade?.tipo_produto || '').toLowerCase() === 'termocloud';
        },
    },
    data() {
        return {
            showModal: false,
            selectedMotor: {},
            disable: false
        };
    },
    methods: {
        motoresOrdenados(motores) {
            return motores.sort((a, b) => a.descricao.localeCompare(b.descricao));
        },
        openModal(motor) {
            this.selectedMotor = motor;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedMotor = {};
        },
        async sendCommandManual(command) {
            this.disable = true
            const datas = {
                descricao: this.selectedMotor.descricao,
                modulo: this.selectedMotor.modulo,
                saida: this.selectedMotor.saida,
                comando: command,
            };
            try {
                let response = await this.$store.dispatch('silo/SendMotorManualCommand', {"data": datas, "siloId": this.siloId})
                this.toast.info(`Comando do motor enviado ao ${this.isTermocloud ? 'TermoCloud' : 'Painel TermoWeb'}, aguardando confirmação...`, { timeout: 3900 });
                let messageId = response.message.message_id;
                setTimeout(async () => {
                    let msg = await this.$store.dispatch("message/fetchMessage", messageId);
                    if (msg.status !== 'processed') {
                        this.toast.error("O painel não conseguiu receber o comando.");
                    } else {
                        this.toast.success("Comando enviado ao motor.");
                    }
                }, 4000);
            } catch (error) {
                this.toast.error(error.response.data.message || "Erro ao enviar comando manual");
            }
            this.disable = false

        }
    },
};
</script>
